import keys from '@debbie/common/dist/cache/keys.js';
import { courts, getCourt, getDirectorNameAddress, getWarningDate, } from '@debbie/common/dist/court/index.js';
import { getContactPerson, getDebtorsOnCustomer, } from '@debbie/common/dist/customers/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { DKTribunalCaseType } from '@debbie/common/dist/tribunal/cases/countries/denmark.js';
import { DKTribunalJobType, shouldRequestPhoneMeeting, } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { useCaseConditions } from '@debbie/cortex/dist/case-conditions/index.js';
import { caseVouchersEntity, useCaseVouchersByCase, } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { creditorsEntity, useCreditor, } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useFixedDistributionsByCaseId } from '@debbie/cortex/dist/fixed-distributions/index.js';
import { useReadyToSubmit } from '@debbie/cortex/dist/heavy-calculations/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { interactionsEntity, useInteractionsByReference, } from '@debbie/cortex/dist/interactions/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTemplates } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { tribunalCasesEntity, tribunalJobsEntity, } from '@debbie/cortex/dist/tribunal/index.js';
import { ensureUpdatesLoadedByRef, updatesEntity, useUpdatesByRefId, } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { encodeText, parseText } from '../../../../../utils/templates.js';
import CaseVoucherTypeInput from '../../../../economy/CaseVoucherTypeInput.js';
import { useEditorState } from '../../../../editor/hooks.js';
import { Col, Row } from '../../../../Grid/index.js';
import { Alert, Button, ButtonGroup, DateInput } from '../../../../index.js';
import { PDFTemplatePreviewModal } from '../../../../interactions/PDFTemplatePreview.js';
import BPDescInput from './BPDescInput.js';
import CourtSelect from './CourtSelect.js';
import Interest from './Interest.js';
import Rubrik2 from './Rubrik2.js';
import Rubrik7 from './Rubrik7.js';
import Rubrik8 from './Rubrik8.js';
import * as utils from './utils/index.js';
const Betalingspaakrav = (props) => {
    const [documentState, setDocumentReactState] = useState({
        ...utils.initialDocumentState,
        ...utils.getDocumentsFromStorage(),
        ...(props.prefill &&
            Object.entries(props.prefill).reduce((acc, [key, value]) => {
                if (typeof value !== 'undefined') {
                    if (['createDate', 'remindingDate'].includes(key)) {
                        acc[key] = moment(value);
                    }
                    else if (key === 'sagsfremstilling') {
                        acc.bpDesc = value;
                    }
                    else if (key === 'courtId' &&
                        courts.find((c) => c.courtId === value)) {
                        acc.court = courts.find((c) => c.courtId === value);
                    }
                    else {
                        acc[key] = value;
                    }
                }
                return acc;
            }, {})),
    });
    const { courtFee, createDate, interestFromSubmitOfBPK, remindingDate, preventForkyndt, preventAutDistress, notDirectlyToCivilCourt, sendInfoToEconomyResponsible, addCourtFeeToCase, addCourtDisbursementToClientBilling, addCourtFeeToClientBilling, directorNameAddress, debtorUserOnCustomerIds, } = documentState;
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const tenant = useTenant();
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const meRole = useRole();
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const caseInteractionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId);
    const caseInteractions = (h.hasData(caseInteractionsLoadable)
        ? caseInteractionsLoadable.data
        : []) || [];
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const caseUpdates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const templatesLoadable = useTemplates();
    const templates = h.hasData(templatesLoadable) ? templatesLoadable.data : null;
    const contactPerson = customer && singleCase && getContactPerson(customer, singleCase);
    const caseVouchers = _caseVouchers ? _caseVouchers : [];
    const [sagsfremstillingEdited, setSagsfremstillingEdited] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [economyResponsibleUserId, setEconomyResponsibleUserId] = useState(localStorage.economyResponsibleUserId || null);
    const [excludeVoucherTypeIds, setExcludeVoucherTypeIds] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isDirectorInitialized, setIsDirectorInitialized] = useState(false);
    const descState = useEditorState();
    const saveSagsfremstilling = useMutation(async (creditor) => {
        await creditorsAPI.update(creditor.creditorId, {
            settings: {
                ...creditor.settings,
                courtSubmitConfig: {
                    ...creditor.settings.courtSubmitConfig,
                    sagsfremstilling: descState.html != '<p></p>'
                        ? parseText(descState.html, mentionSuggestions)
                        : '',
                },
            },
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    }, {
        onError: () => alert('Error saving'),
    });
    const court = getCourt(contactPerson, documentState.court);
    const tenantSagsfremstilling = tenant?.settings.tribunal?.caseTypes &&
        tenant.settings.tribunal?.caseTypes[DKTribunalCaseType.DKBetalingspaakrav] &&
        tenant.settings.tribunal?.caseTypes[DKTribunalCaseType.DKBetalingspaakrav]
            .sagsfremstilling;
    useEffect(() => {
        if (isDirectorInitialized || !customer || !isInitialized) {
            return;
        }
        if (!customer.isCompany) {
            setIsDirectorInitialized(true);
            return;
        }
        const prefill = getDirectorNameAddress(getDebtorsOnCustomer(customer));
        if (!prefill) {
            return;
        }
        setIsDirectorInitialized(true);
        setDocumentReactState((prev) => prev.directorNameAddress
            ? prev
            : { ...prev, directorNameAddress: prefill });
    }, [customer, isInitialized]);
    useEffect(() => {
        if (creditor && caseInteractions && caseUpdates && templates && tenant) {
            if (!isInitialized) {
                setIsInitialized(true);
                // Set sagsfremstilling
                const content = encodeText(creditor.settings?.courtSubmitConfig?.sagsfremstilling ||
                    tenantSagsfremstilling ||
                    utils.bpkDescTemplate, mentionSuggestions);
                descState.overwriteEditorContent(content);
                setExcludeVoucherTypeIds(tenant?.settings?.tribunal?.caseTypes?.[DKTribunalCaseType.DKBetalingspaakrav]?.excludeVoucherTypeIds || []);
                const _remindingDate = getWarningDate(caseInteractions, caseUpdates, templates);
                // Set court settings
                setDocumentState({
                    ...documentState,
                    ...(_remindingDate ? { remindingDate: moment(_remindingDate) } : {}),
                    ...(typeof creditor.settings.courtSubmitConfig?.preventForkyndt ===
                        'boolean'
                        ? {
                            preventForkyndt: creditor.settings.courtSubmitConfig.preventForkyndt,
                        }
                        : {}),
                    ...(typeof creditor.settings.courtSubmitConfig?.preventAutDistress ===
                        'boolean'
                        ? {
                            preventAutDistress: creditor.settings.courtSubmitConfig.preventAutDistress,
                        }
                        : {}),
                    ...(typeof creditor.settings.courtSubmitConfig
                        ?.notDirectlyToCivilCourt === 'boolean'
                        ? {
                            notDirectlyToCivilCourt: creditor.settings.courtSubmitConfig.notDirectlyToCivilCourt,
                        }
                        : {}),
                    ...(typeof creditor.settings.courtSubmitConfig
                        ?.sendInfoToEconomyResponsible === 'boolean'
                        ? {
                            sendInfoToEconomyResponsible: creditor.settings.courtSubmitConfig
                                ?.sendInfoToEconomyResponsible,
                        }
                        : {}),
                    ...(typeof creditor.settings.courtSubmitConfig
                        ?.addCourtDisbursementToClientBilling === 'boolean'
                        ? {
                            addCourtDisbursementToClientBilling: creditor.settings.courtSubmitConfig
                                ?.addCourtDisbursementToClientBilling,
                        }
                        : {}),
                    ...(typeof creditor.settings.courtSubmitConfig
                        ?.addCourtFeeToClientBilling === 'boolean'
                        ? {
                            addCourtFeeToClientBilling: creditor.settings.courtSubmitConfig
                                ?.addCourtFeeToClientBilling,
                        }
                        : {}),
                });
                if (creditor.settings.courtSubmitConfig?.economyResponsibleUserId) {
                    setEconomyResponsibleUserId(creditor.settings.courtSubmitConfig?.economyResponsibleUserId);
                }
            }
        }
    }, [creditor, caseInteractions, templates, tenant]);
    const setDocumentState = (addToState) => {
        const newState = {
            ...documentState,
            ...addToState,
        };
        setDocumentReactState(newState);
    };
    const getJobData = () => ({
        courtId: court?.courtId || '',
        sendInfoToEconomyResponsible,
        economyResponsibleUserId,
        addCourtFeeToCase,
        addCourtFeeToClientBilling,
        addCourtDisbursementToClientBilling,
        courtFee,
        excludeVoucherTypeIds,
        sagsfremstilling: descState.html != '<p></p>'
            ? parseText(descState.html, mentionSuggestions)
            : '',
        directorNameAddress: customer?.isCompany
            ? directorNameAddress || undefined
            : undefined,
        debtorUserOnCustomerIds: debtorUserOnCustomerIds || undefined,
        remindingDate: (remindingDate && remindingDate.toISOString()),
        interestFromSubmitOfBPK,
        preventForkyndt,
        preventAutDistress,
        notDirectlyToCivilCourt,
        phoneMeetingRequested: shouldRequestPhoneMeeting(-helpers.overview.balance(caseVouchers), tenant?.settings?.tribunal?.caseTypes?.[DKTribunalCaseType.DKBetalingspaakrav]?.noPhoneMeetingBelowAmount),
        createDate: (createDate && createDate.toISOString()),
    });
    const createTribunalCase = async () => {
        if (singleCase) {
            setLoading(true);
            if (!court) {
                throw new Error('Could not find court');
            }
            try {
                await tribunalAPI.createTribunalJob({
                    type: props.resending
                        ? DKTribunalJobType.ResendBetalingspaakrav
                        : DKTribunalJobType.CreateBetalingspaakrav,
                    tribunalCaseId: props.tribunalCaseId,
                    data: getJobData(),
                    caseId: singleCase?.caseId,
                    reference: null,
                });
                if (singleCase) {
                    q.invalidate([...keys.write.create(updatesEntity)]);
                    q.invalidate([...keys.write.create(caseVouchersEntity)]);
                    q.invalidate([...keys.write.create(interactionsEntity)]);
                    await ensureUpdatesLoadedByRef(singleCase.caseId);
                }
                props.onCreated && props.onCreated();
            }
            catch (err) {
                alert(lang.tribunal.couldNotCreateTribunalCase);
            }
            setLoading(false);
            q.invalidate([
                ...keys.write.create(tribunalJobsEntity),
                ...keys.write.create(tribunalCasesEntity),
            ]);
        }
        else {
            throw new Error('Could not find single case');
        }
    };
    const fixedDistributionsLoader = useFixedDistributionsByCaseId(props.caseId);
    const fixedDistributions = h.hasData(fixedDistributionsLoader)
        ? fixedDistributionsLoader.data
        : null;
    const conditionsLoader = useCaseConditions(props.caseId);
    const conditions = h.hasData(conditionsLoader) ? conditionsLoader.data : null;
    const readyToSubmitLoader = useReadyToSubmit({
        case: singleCase,
        creditor,
        caseVouchers,
        customer,
        documents,
        interactions: caseInteractions,
        updates: caseUpdates,
        templates,
        tenant,
        fixedDistributions,
        conditions,
    }, creditor?.settings.courtSubmitConfig);
    const submitValidation = creditor?.settings.courtSubmitConfig && h.hasData(readyToSubmitLoader)
        ? readyToSubmitLoader.data
        : null;
    return (React.createElement("div", null,
        h.isError(conditionsLoader) && (React.createElement(Alert, { message: lang.costCeiling.failedToLoad, size: "small" })),
        submitValidation &&
            submitValidation.errors.map((error) => (React.createElement(Alert, { message: lang.courtSubmitErrors[error], size: "small", key: error }))),
        React.createElement(Rubrik2, { directorNameAddress: directorNameAddress || '', debtorUserOnCustomerIds: debtorUserOnCustomerIds, setDocumentState: setDocumentState, singleCase: singleCase }),
        React.createElement(CourtSelect, { caseSeqId: props.caseSeqId, court: court, setDocumentState: setDocumentState }),
        React.createElement(Interest, { setDocumentState: setDocumentState, interestFromSubmitOfBPK: !!documentState.interestFromSubmitOfBPK }),
        !!tenant?.settings.tribunal?.caseTypes?.[DKTribunalCaseType.DKBetalingspaakrav]?.excludeVoucherTypeIds?.length && (React.createElement("div", { style: { zIndex: 9 } },
            React.createElement("p", null, "Ekskluder udvalgte sagsposteringstyper."),
            React.createElement(CaseVoucherTypeInput, { placeholder: "V\u00E6lg sagsposteringstyper som skal fratr\u00E6kkes ved indlevering", voucherTypeIds: excludeVoucherTypeIds, onChange: (voucherTypeIds) => {
                    setExcludeVoucherTypeIds(voucherTypeIds);
                }, excludeVoucherCategories: [VoucherCategory.TRANSACTION] }))),
        React.createElement(BPDescInput, { bpDesc: documentState.bpDesc, setDocumentState: setDocumentState, editorState: {
                ...descState,
                onChange: (html) => {
                    if (!sagsfremstillingEdited) {
                        setSagsfremstillingEdited(true);
                    }
                    descState.onChange(html);
                },
            } }),
        sagsfremstillingEdited && meRole && isAdmin(meRole) && (React.createElement("p", null,
            React.createElement(Button, { size: "mini", theme: "secondary", loading: saveSagsfremstilling.isLoading, onClick: () => {
                    if (creditor) {
                        setSagsfremstillingEdited(false);
                        saveSagsfremstilling.mutate(creditor);
                    }
                } }, "Gem sagsfremstilling p\u00E5 kreditor"))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", null, "Rubrik 6"),
                React.createElement(DateInput, { placeholder: lang.documents.selectBPKWarningDate, value: remindingDate, onChange: (e) => setDocumentState({
                        remindingDate: e,
                    }), allowNull: true }))),
        React.createElement(Rubrik7, { preventForkyndt: preventForkyndt, setDocumentState: setDocumentState, preventAutDistress: preventAutDistress, notDirectlyToCivilCourt: notDirectlyToCivilCourt }),
        React.createElement(Rubrik8, { courtFee: courtFee, sendInfoToEconomyResponsible: sendInfoToEconomyResponsible, addCourtFeeToCase: addCourtFeeToCase, addCourtDisbursementToClientBilling: addCourtDisbursementToClientBilling, addCourtFeeToClientBilling: addCourtFeeToClientBilling, setDocumentState: setDocumentState, economyResponsibleUserId: economyResponsibleUserId, setEconomyResponsibleUserId: setEconomyResponsibleUserId }),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", null, "Rubrik 9"),
                React.createElement(Row, null,
                    React.createElement(Col, { width: "6" },
                        React.createElement(DateInput, { placeholder: lang.documents.createDate, value: createDate, onChange: (e) => setDocumentState({
                                createDate: e,
                            }), allowNull: true }))))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { size: "small", onClick: createTribunalCase, disabled: !(singleCase &&
                            court &&
                            court.courtId &&
                            remindingDate &&
                            createDate), loading: loading }, lang.tribunal.createTribunalCase),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => setPreviewModalOpen(!previewModalOpen) }, lang.documents.preview)))),
        previewModalOpen && props.caseSeqId && singleCase && (React.createElement(PDFTemplatePreviewModal, { caseId: singleCase.caseId, templateId: '07fecc4e-138c-4b9d-a998-ea50a222a3b0', onToggle: () => setPreviewModalOpen(!previewModalOpen), data: {
                dkBPKTribunalJobData: getJobData(),
                excludeVoucherTypeIds,
                caseVouchersAsOfDate: moment(createDate).toISOString(),
            } }))));
};
export default Betalingspaakrav;
//# sourceMappingURL=Betalingspaakrav.js.map